import { createI18n, useI18n as useVueI18n } from 'vue-i18n'
import en from './en'
import zh from './zh'
import zhTW from './zh-TW'

const messages = { en, zh, 'zh-TW': zhTW }

export const langNames = {
  en: 'English',
  zh: '简体中文',
  'zh-TW': '繁體中文'
}
export const langList = ['en', 'zh', 'zh-TW']

// 获取存储的语言或浏览器语言
function getDefaultLang() {
  const stored = localStorage.getItem('lang')
  if (stored && langList.includes(stored)) {
    return stored
  }
  const browserLang = navigator.language.toLowerCase()
  if (browserLang.startsWith('zh-tw') || browserLang.startsWith('zh-hk')) {
    return 'zh-TW'
  }
  if (browserLang.startsWith('zh')) {
    return 'zh'
  }
  return 'en'
}

// 调试：打印消息对象
console.log('=== i18n初始化 ===')
console.log('语言包:', Object.keys(messages))
console.log('默认语言:', getDefaultLang())

// 检查消息格式
Object.entries(messages).forEach(([lang, msgs]) => {
  try {
    // 递归检查是否有问题的格式
    const checkMessages = (obj, path = '') => {
      for (const [key, value] of Object.entries(obj)) {
        const currentPath = path ? `${path}.${key}` : key
        if (typeof value === 'string') {
          // 检查是否有问题的格式
          if (value.includes('@:') || value.includes('@[') || value.includes('@{')) {
            console.error(`!!! 发现链接语法 ${lang}.${currentPath}: "${value}"`)
          }
          if (value.includes('{') && value.includes('}')) {
            console.warn(`发现变量语法 ${lang}.${currentPath}: "${value}"`)
          }
        } else if (typeof value === 'object' && value !== null) {
          checkMessages(value, currentPath)
        }
      }
    }
    checkMessages(msgs)
  } catch (e) {
    console.error(`检查语言包 ${lang} 出错:`, e)
  }
})

// 创建 i18n 实例
let i18n
try {
  i18n = createI18n({
    legacy: false, // 使用 Composition API 模式
    locale: getDefaultLang(),
    fallbackLocale: 'en',
    messages,
    // 在生产环境下禁用警告
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    // 修复链接格式问题
    missingWarn: false,
    fallbackWarn: false,
    // 使用运行时编译器
    globalInjection: true,
    // 允许HTML内容
    allowComposition: true
  })
  console.log('✓ i18n实例创建成功')
} catch (error) {
  console.error('!!! i18n创建失败:', error)
  throw error
}

export default i18n

// 设置语言
export function setLang(lang) {
  if (langList.includes(lang)) {
    i18n.global.locale.value = lang
    localStorage.setItem('lang', lang)
    document.documentElement.lang = lang
  }
}

// 切换语言（循环切换）
export function toggleLang() {
  const currentIndex = langList.indexOf(i18n.global.locale.value)
  const nextIndex = (currentIndex + 1) % langList.length
  setLang(langList[nextIndex])
}

// 获取语言名称
export function getLangName(lang) {
  return langNames[lang] || lang
}

// 导出 composable 函数，用于在组件中使用
// 这个函数包装了 vue-i18n 的 useI18n，并添加了额外的功能
export function useI18n() {
  const { locale, t } = useVueI18n()
  
  return {
    lang: locale,
    t,
    setLang,
    langList,
    getLangName
  }
}
